import React, { useEffect, useState } from 'react'
import "./iam.css"
import VideoModal from '../components/VideoModal';
import { MdArrowForward } from 'react-icons/md';

const EmployeeCards = ({cards, selected}) => {

    const [open, setOpen] = useState(false);
    const [demoData, setDemoData] = useState();
    const handleOpen = (videoData) => {
        setDemoData(videoData)
        setOpen(true);
    };
    const handleClose = () => setOpen(false);

    const filteredCards = cards?.filter(item => item?.cardType === "employee") || [];
    const uniqueSubcategories = [
        ...new Set(filteredCards?.map(item => item?.subCategory)?.filter(Boolean)),
    ];

    useEffect(()=> {
            if (selected === "all") {
                const e = document.getElementById("sso");
                e.scrollIntoView({ behavior: "smooth", block: "start" })
            };
            const element = document.getElementById(selected);
            console.log("element", element)
            if (element) {
                element.scrollIntoView({ behavior: "smooth", block: "start" });
              }
    }, [selected])

  return (
    <>
        <div className="d-flex flex-column flex-1 overflow-y-auto overflow-x-hidden pe-4" style={{ height: "calc( 100vh - 270px)"}}>
            <div className="row g-3 pb-1">
                {uniqueSubcategories?.map((subCategory, index) => (
                    <div key={index} id={subCategory.toLowerCase()}>
                        <h6 className="my-4 fw-bold">{subCategory}</h6>
                        <div className="row g-5">
                            {filteredCards
                                ?.filter(item => item?.subCategory === subCategory)
                                ?.map((item, index) => (
                                <div key={index} className="col-sm-12 col-md-6 col-lg-4 col-xl-3 card-hover-wrapper">
                                    <div className="custom-shadow d-flex flex-column border rounded-4 px-4 py-4 align-items-start h-100" onClick={()=> handleOpen(item)} >
                                        <div className="d-flex align-items-center justify-content-center text-14 border rounded-3 mb-3">
                                            <div className="d-flex justify-content-center align-items-center m-2 rounded-circle" style={{ height: "40px", width: "40px" }} >
                                                {item?.icon}
                                            </div>
                                        </div>
                                        <div className="d-flex flex-column">
                                            <span style={{ fontWeight: 500, fontSize: "17px" }}>
                                                {item?.text}
                                            </span>
                                            <span className="font-14 fw-normal" style={{ color: "#a7a7a7" }}>
                                                {item?.desc}
                                            </span>
                                        </div>
                                        <div className="watch-btn fw-medium" style={{color:"#EB5424"}}>
                                            Watch now <MdArrowForward />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
        {open &&
            <VideoModal
                open={open}
                handleOpen={handleOpen}
                handleClose={handleClose}
                videoData={demoData}
            />
        }
    </>
  )
}

export default EmployeeCards